const state = {
};

export default state;



// WEBPACK FOOTER //
// ./scripts/store/state.js